__turbopack_context__.v({
  "className": "inter_fa357f3e-module__kqVV3a__className",
  "variable": "inter_fa357f3e-module__kqVV3a__variable",
});
